var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCircleX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 542 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338.75 338.75L203.25 203.25M338.75 203.25L203.25 338.75",
    className: "svgStroke",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271 496.833C395.724 496.833 496.833 395.724 496.833 271C496.833 146.276 395.724 45.1667 271 45.1667C146.276 45.1667 45.1666 146.276 45.1666 271C45.1666 395.724 146.276 496.833 271 496.833Z",
    className: "svgStroke",
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCircleX2);
export default __webpack_public_path__ + "static/media/akar-icons_circle-x2.6143efca.svg";
export { ForwardRef as ReactComponent };